export enum EntityActive {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
